import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { forwardRef } from 'react';
import { IconContext } from '../context';
const SvgCheck = (props, ref) => {
    const iconContext = React.useContext(IconContext);
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size ?? iconContext.size ?? 24, height: props.size ?? iconContext.size ?? 24, fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: _jsx("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M20 6 9 17l-5-5" }) }));
};
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
